define('views/content/reports/upcoming_licenses',['require','backbone','marionette','datatables','text!templates/content/reports/upcoming_licenses.html'],function(require) {

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');

    var temp = require("text!templates/content/reports/upcoming_licenses.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'upcoming_licenses',

        initialize: function (options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },
        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                upcomingLicensesTable: '.upcoming-licenses-list'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.getReports();
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));

                this.getReports();
            } else {
                this.ui.reportDateRangeTabs.find('li[data-range="day"]').click();
            }

        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'last_30_days') {
                    var monthAgo = new Date(tomorrow.getTime());
                    monthAgo.setDate(monthAgo.getDate() - 30);

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthAgo);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.getReports();
            }
        },

        getReports: function () {
            var _this = this;

            // Save date parameters in local storage
            localStorage.setItem('report_start_time', this.ui.reportDateRangePicker.data('daterangepicker').startDate.toDate().getTime());
            localStorage.setItem('report_end_time', this.ui.reportDateRangePicker.data('daterangepicker').endDate.toDate().getTime());

            $.ajax({
                url: App.Config.apiBase + 'customer-licenses/',
                method: 'get',
                data: {
                    end_time_gte: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_time_lte: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD'),
                    ordering: '-end_time'
                },
                success: function (response) {
                   _this.showUpcomingLicensesReports(response.results);
                }
            });
        },

        showUpcomingLicensesReports: function (reportData) {
            var gridData = [];
            reportData.forEach(function (reportRow) {
                if(reportRow.assignor) {
                    gridData.push([
                        '<a href="/customers/' + reportRow.customerdetail.id + '">' + reportRow.customerdetail.company_name + '<a/>',
                        '<a href="/customers/' + reportRow.customerdetail.id + '">' + reportRow.license_email + '<a/>',
                        reportRow.product.name,
                        '<a href="/resellers/' + reportRow.assignor.id + '">' + reportRow.assignor.company_name + '<a/>',
                        reportRow.start_time,
                        reportRow.end_time
                    ]);
                }
            });
            if (!this.upcomingLicensesTable) {
                this.upcomingLicensesTable = this.ui.upcomingLicensesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('customer') },
                        { title: App.polyglot.t('email'), className: 'text-right' },
                        { title: App.polyglot.t('product'), className: 'text-right' },
                        { title: App.polyglot.t('reseller'), className: 'text-right' },
                        { title: App.polyglot.t('start_time'), className: 'text-right' },
                        { title: App.polyglot.t('end_time'), className: 'text-right' }
                    ]
                });
            }else {
                this.upcomingLicensesTable.clear();
                this.upcomingLicensesTable.rows.add(gridData);
                this.upcomingLicensesTable.columns.adjust().draw();
            }


        }
    });
});
